import { render, staticRenderFns } from "./ModalFullHeightRight.vue?vue&type=template&id=20bf28c8&scoped=true"
import script from "./ModalFullHeightRight.vue?vue&type=script&lang=js"
export * from "./ModalFullHeightRight.vue?vue&type=script&lang=js"
import style0 from "./ModalFullHeightRight.vue?vue&type=style&index=0&id=20bf28c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bf28c8",
  null
  
)

export default component.exports